<script>
import { BDropdownForm } from "bootstrap-vue";

export default {
  extends: BDropdownForm
};
</script>